import styled, { css } from 'styled-components'

export interface TimelineStyledProps {
  $showLine?: boolean
}

export const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<TimelineStyledProps>`
  position: relative;
  padding-left: 0;
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};

  ${({ $showLine }) =>
    $showLine &&
    css`
      &::before {
        content: '';
        position: absolute;
        left: 40px;
        top: 20px;
        bottom: 60px;
        width: 2px;
        background: ${({ theme }) => theme.colors.border.light};

        @media (max-width: 768px) {
          display: none;
        }
      }
    `}
`

export const LoadMoreContainer = styled.div`
  text-align: center;
  margin-top: 32px;
`

export const LoadMoreButton = styled.button`
  padding: 6px 12px;
  border-radius: ${({ theme }) => theme.borderRadius.default};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  background: ${({ theme }) => theme.colors.background.primary};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.background.tertiary};
    border-color: ${({ theme }) => theme.colors.text.tertiary};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .icon {
    width: 14px;
    height: 14px;
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
  }
`
